import { render, staticRenderFns } from "./FormControlModulestructureDefaultValue.vue?vue&type=template&id=3ab4c5a8"
import script from "./FormControlModulestructureDefaultValue.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulestructureDefaultValue.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports